import styled from "styled-components";
import theme from "../../styles/theme";
export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  .loading {
    background-color: white;
    height: 100%;
    align-content: center;
    justify-items: center;
    .lbl {
      color: black;
      font-size: ${theme.fontSize.md2};
    }
  }
  @media ${theme.devices.tablet} {
  }
`;
